import React from 'react';

import { css } from '@emotion/react';
import { SemanticColorToken, Type, mediaQueryForExperimentalLayoutSizeMDOrSmaller } from '@robinhood/design';
import LottiePlayer, { AnimationItem } from 'lottie-web';

import GoldFeatherSpinner from 'src/assets/lotties/GoldFeatherSpinner.json';
import GradientBackgroundLayout from 'src/components/creditApplication/GradientBackgroundLayout';

interface PropsIface {
  loadingText?: string;
}

const LoadingPage = ({ loadingText = 'Just a moment' }: PropsIface) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const animationRef = React.useRef<AnimationItem | null>(null);
  React.useEffect(() => {
    if (containerRef.current) {
      animationRef.current = LottiePlayer.loadAnimation({
        container: containerRef.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: GoldFeatherSpinner,
      });
    }
  }, []);
  return (
    <GradientBackgroundLayout>
      <div css={root}>
        <div ref={containerRef} css={lottie} />
        <Type.Text size='M' color={SemanticColorToken.Positive}>
          {loadingText}
        </Type.Text>
      </div>
    </GradientBackgroundLayout>
  );
};

const root = css`
  margin-top: 100px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const lottie = css`
  width: 200px;
  height: 200px;

  ${mediaQueryForExperimentalLayoutSizeMDOrSmaller} {
    width: 120px;
    height: 120px;
  }
`;

export default LoadingPage;
